import { render, staticRenderFns } from "./TableManagers.vue?vue&type=template&id=bf169e7a&"
import script from "./TableManagers.vue?vue&type=script&lang=js&"
export * from "./TableManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports